import { FileRepresentation } from '@/components/form-builder/form-builder.types';

const decodeBase64 = (base64String: string): Uint8Array<ArrayBuffer> => {
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  return new Uint8Array(byteNumbers);
};

const getMimeType = (ext: string): string => {
  const map: Record<string, string> = {
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpeg',
    txt: 'text/plain',
    html: 'text/html',
    zip: 'application/zip',
  };
  return map[ext.toLowerCase()] || 'application/octet-stream';
};

const triggerNavigatorOpen = (file: FileRepresentation, base64String: string): void => {
  const dataUrl = `data:${getMimeType(file.extension as string)};base64,${base64String}`;

  const newTab = window.open();
  if (newTab) {
    const head = newTab.document.head;
    const title = newTab.document.createElement('title');
    title.innerText = file.filename as string;
    head.appendChild(title);
    const body = newTab.document.body;
    body.style.margin = '0';
    body.style.padding = '0';
    const iFrame = newTab.document.createElement('iframe');
    iFrame.style.width = '100%';
    iFrame.style.height = '100%';
    iFrame.style.border = 'none';
    iFrame.style.margin = '0';
    iFrame.style.padding = '0';
    newTab.document.body.appendChild(iFrame);
    iFrame.src = dataUrl;
  } else {
    console.error('Failed to open new tab. Please check your browser settings.');
  }
};

const readBlobAsBase64 = (blob: Blob): Promise<string> => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.readAsDataURL(blob);
  });
};

const triggerBlobDownload = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

const downloadPdf = (base64Data: string, filename: string): void => {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });
  triggerBlobDownload(blob, filename);
};

export const fileUtils = {
  decodeBase64,
  triggerBlobDownload,
  getMimeType,
  triggerNavigatorOpen,
  downloadPdf,
  readBlobAsBase64,
};
